<template>
  <el-dialog class="pv-video-dialog" :visible.sync="data.visible" :title="title"
             width="620px"
             center
             @opened="handleOpenedVideo"
             @close="handleClosedVideo">
    <div>
      <div class="pv-content">
        <video ref="video" :src="data.src" autoplay loop playsinline>您的浏览器不支持视频播放</video>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: '',
    data: {
      visible: false,
      src: ''
    }
  },
  methods: {
    handleOpenedVideo () {
      let video = this.$refs.video
      video.volume = 0.2
      video.play()
    },
    handleClosedVideo () {
      let video = this.$refs.video
      video.pause()
    }
  }
}
</script>

<style>
.pv-video-dialog .el-dialog {
  background: #e5e9f2;
}

.pv-video-dialog .el-dialog__header {
  padding: 0 20px 0px 20px;
  height: 50px;
  background-color: #fff;
}

.pv-video-dialog .el-dialog__title {
  color: #0C0C0C;
  line-height: 50px;
}

.pv-video-dialog .el-dialog__body {
  padding: 0;
}

.pv-video-dialog .pv-content {
  padding-top: 5px;
  width: 620px;
  min-height: 400px;
  margin-left: auto;
  margin-right: auto;
}

.pv-video-dialog .pv-content video {
  width: 620px;
  height: 450px;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/PreviewVideoDialog.vue